import { render, staticRenderFns } from "./BuckBabies.vue?vue&type=template&id=706a828f&"
import script from "./BuckBabies.vue?vue&type=script&lang=ts&"
export * from "./BuckBabies.vue?vue&type=script&lang=ts&"
import style0 from "./BuckBabies.vue?vue&type=style&index=0&id=706a828f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports